import i18n from '@/i18n'
import { EVENT_CATEGORIES } from '@/tracking/amplitude-helpers'
import { OKR_LEVEL_ENTITY_KEYS } from '@/utils/entity-keys'
import { isKR, OBJECTIVE_TYPES } from '@/utils/objective-types'
import { getProgressOptionByFieldTypeId } from '@/utils/okr-element-values'

export const getLevelParentRequiredValueForTracking = (allowWithoutParent = false) => {
  return allowWithoutParent ? 'no' : 'yes'
}

export const createUpdateLevelTrackingPayload = ({
  snapshot = {},
  payload = {},
  typeId = OBJECTIVE_TYPES.KR
} = {}) => {
  const trackingPayload = {
    category: EVENT_CATEGORIES.LEVEL_MANAGEMENT,
    oldLabel: snapshot[OKR_LEVEL_ENTITY_KEYS.NAME],
    label: payload[OKR_LEVEL_ENTITY_KEYS.NAME],

    oldPrefix: snapshot[OKR_LEVEL_ENTITY_KEYS.PREFIX],
    prefix: payload[OKR_LEVEL_ENTITY_KEYS.PREFIX],

    oldColor: snapshot[OKR_LEVEL_ENTITY_KEYS.COLOR],
    color: payload[OKR_LEVEL_ENTITY_KEYS.COLOR]
  }

  const isMetricLevel = isKR({
    typeId
  })

  if (isMetricLevel) {
    const getProgressOptionName = fieldTypeId => {
      const { label } = getProgressOptionByFieldTypeId(fieldTypeId)

      return i18n.global.t(label, 1, { locale: 'en' }).toLowerCase()
    }

    trackingPayload.oldProgressOptions =
      snapshot[OKR_LEVEL_ENTITY_KEYS.FIELD_TYPE_IDS].map(getProgressOptionName)
    trackingPayload.progressOptions =
      payload[OKR_LEVEL_ENTITY_KEYS.FIELD_TYPE_IDS].map(getProgressOptionName)

    trackingPayload.oldParentRequired = getLevelParentRequiredValueForTracking(
      snapshot[OKR_LEVEL_ENTITY_KEYS.ALLOW_WITHOUT_PARENT]
    )
    trackingPayload.parentRequired = getLevelParentRequiredValueForTracking(
      payload[OKR_LEVEL_ENTITY_KEYS.ALLOW_WITHOUT_PARENT]
    )
  }

  return trackingPayload
}
